// Shared constants that can be used in both server and client components
export const STAGING_API = "https://sismobile.htu.edu.jo/";
export const PRODUCTION_API = "https://htu.edu.jo/";

// Default cover photo URL for OpenGraph meta tags
export const DEFAULT_COVER_PHOTO = `${STAGING_API}upload/Default_Cover_Photo.83911f1f.jpg`;

// Font URLs for preloading
export const FONTS = {
  FA_REGULAR: `${STAGING_API}fonts/fonts/fa-regular-400.woff2`,
  FA_BRANDS: `${STAGING_API}fonts/fonts/fa-brands-400.woff2`,
  FA_LIGHT: `${STAGING_API}fonts/fonts/fa-light-300.woff2`,
  FA_SOLID: `${STAGING_API}fonts/fonts/fa-solid-900.woff2`,
  FA_THIN: `${STAGING_API}fonts/fonts/fa-thin-100.woff2`,
  FA_V4_COMPAT: `${STAGING_API}fonts/fonts/fa-v4compatibility.woff2`,
  PRESS_START: `${STAGING_API}fonts/fonts/PressStart2P.ttf`,
  SCALA_LIGHT: `${STAGING_API}fonts/fonts/ScalaSansPro-Light.otf`,
  SCALA_REGULAR: `${STAGING_API}fonts/fonts/ScalaSansPro-Regular.otf`,
  SCALA_BOLD: `${STAGING_API}fonts/fonts/ScalaSansPro-Bold.otf`,
  SCALA_BLACK: `${STAGING_API}fonts/fonts/ScalaSansPro-Black.otf`,
  THAMEEN_LIGHT: `${STAGING_API}fonts/fonts/GE Thameen Light.otf`,
  THAMEEN_REGULAR: `${STAGING_API}fonts/fonts/GE Thameen.otf`,
  THAMEEN_BOLD: `${STAGING_API}fonts/fonts/GE Thameen Bold.otf`,
};
